"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./drawer.css");

exports.default = {
  drawer: 'pf-c-drawer',
  drawerSection: 'pf-c-drawer__section',
  drawerMain: 'pf-c-drawer__main',
  drawerContent: 'pf-c-drawer__content',
  drawerPanel: 'pf-c-drawer__panel',
  drawerHead: 'pf-c-drawer__head',
  drawerActions: 'pf-c-drawer__actions',
  drawerBody: 'pf-c-drawer__body',
  pageMain: 'pf-c-page__main',
  drawerClose: 'pf-c-drawer__close',
  modifiers: {
    'noBackground': 'pf-m-no-background',
    'noPadding': 'pf-m-no-padding',
    'padding': 'pf-m-padding',
    'expanded': 'pf-m-expanded',
    'panelLeft': 'pf-m-panel-left',
    'border': 'pf-m-border',
    'noBorder': 'pf-m-no-border',
    'width_25': 'pf-m-width-25',
    'width_33': 'pf-m-width-33',
    'width_50': 'pf-m-width-50',
    'width_66': 'pf-m-width-66',
    'width_75': 'pf-m-width-75',
    'width_100': 'pf-m-width-100',
    'width_25OnLg': 'pf-m-width-25-on-lg',
    'width_33OnLg': 'pf-m-width-33-on-lg',
    'width_50OnLg': 'pf-m-width-50-on-lg',
    'width_66OnLg': 'pf-m-width-66-on-lg',
    'width_75OnLg': 'pf-m-width-75-on-lg',
    'width_100OnLg': 'pf-m-width-100-on-lg',
    'width_25OnXl': 'pf-m-width-25-on-xl',
    'width_33OnXl': 'pf-m-width-33-on-xl',
    'width_50OnXl': 'pf-m-width-50-on-xl',
    'width_66OnXl': 'pf-m-width-66-on-xl',
    'width_75OnXl': 'pf-m-width-75-on-xl',
    'width_100OnXl': 'pf-m-width-100-on-xl',
    'width_25On_2xl': 'pf-m-width-25-on-2xl',
    'width_33On_2xl': 'pf-m-width-33-on-2xl',
    'width_50On_2xl': 'pf-m-width-50-on-2xl',
    'width_66On_2xl': 'pf-m-width-66-on-2xl',
    'width_75On_2xl': 'pf-m-width-75-on-2xl',
    'width_100On_2xl': 'pf-m-width-100-on-2xl',
    'inline': 'pf-m-inline',
    'static': 'pf-m-static',
    'inlineOnLg': 'pf-m-inline-on-lg',
    'staticOnLg': 'pf-m-static-on-lg',
    'inlineOnXl': 'pf-m-inline-on-xl',
    'staticOnXl': 'pf-m-static-on-xl',
    'inlineOn_2xl': 'pf-m-inline-on-2xl',
    'staticOn_2xl': 'pf-m-static-on-2xl'
  }
};